import React, { useState } from "react";
import { toast } from "react-toastify";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import { Router, useNavigate } from "react-router-dom";
import PrintIcon from "@mui/icons-material/Print";

// import JS files
import { useUserData } from "../../../../context/UserDataContext";
import PanelTable from "../../../shares/PanelTable";
import useFetch from "../../../../context/useFetch";
import { fixNumbers } from "../../../../utils";
import PanelFilter from "../../../shares/PanelFilter";
import PanelTemplate from "../../../shares/PanelTemplate";
import MuiButton from "../../../shares/MuiButton";

const AdminReportOrderStock = () => {
  const navigate = useNavigate();
  const [codeFilter, setCodeFilter] = useState(null);
  const [customerFilter, setCustomerFilterr] = useState(null);

  const headersList = [
    // { colName: "code", name: "کد" },
    { colName: "show_name", name: "النگو" },
    { colName: "brand", name: "برند" },
    { colName: "gender", name: "سن" },
    { colName: "color", name: "رنگ" },
    { colName: "size_one_num", name: " س.یک" },
    { colName: "size_two_num", name: " س.دو" },
    { colName: "size_three_num", name: " س.سه" },
    { colName: "size_four_num", name: " س.چهار" },
    { colName: "size_five_num", name: " س.پنج" },
    { colName: "size_six_num", name: " س.شش" },

    { colName: "size_one_num", name: " م.یک" },
    { colName: "size_two_num", name: " م.دو" },
    { colName: "size_three_num", name: " م.سه" },
    { colName: "size_four_num", name: " م.چهار" },
    { colName: "size_five_num", name: " م.پنج" },
    { colName: "size_six_num", name: " م.شش" },
  ];

  const mobileHeadersList = [
    { colName: "code", name: "کد" },
    { colName: "show_name", name: "النگو" },
    { colName: "brand", name: "برند" },
  ];

  const dataKey = [
    "code",
    "show_name",
    "brand_name",
    "gender",
    "color",
    "object.order_nums.size_one_num",
    "object.order_nums.size_two_num",
    "object.order_nums.size_three_num",
    "object.order_nums.size_four_num",
    "object.order_nums.size_five_num",
    "object.order_nums.size_six_num",
    "object.stock_nums.size_one_num",
    "object.stock_nums.size_two_num",
    "object.stock_nums.size_three_num",
    "object.stock_nums.size_four_num",
    "object.stock_nums.size_five_num",
    "object.stock_nums.size_six_num",
  ];
  const [customerPagination, setCustomerPagination] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
    next: null,
    previous: null,
  });
  const [customerList, setCustomerList] = useState({ results: [] });

  const filterList = [
    {
      type: "textField",
      label_fa: "کد",
      label_en: "code",
      state: codeFilter,
      isLTR: true,
    },
  ];

  const update_filter = (state, e) => {
    if (state == "code") setCodeFilter(e.length > 0 ? e : null);
    if (state == "customer") setCustomerFilterr(e);
  };

  const filter = () => {
    getRequestListApi.reFetch();
  };

  const reset_filter = () => {
    setCodeFilter(null);
    setCustomerFilterr(null);
    getRequestListApi.reFetch();
  };

  const [requestList, setRequestList] = useState([]);

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
  });

  const getRequestListApi = useFetch({
    method: "get",
    params: {
      code: fixNumbers(codeFilter),
      customer: customerFilter,
    },
    url: `User_Service/${useUserData.username}/admin_get_report_bangle_statistics`,
    trigger: true,
    pagination: paginationPageInfo,
    setter: setRequestList,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const buttonsList = [];

  const actionsList = [];

  const handelPrintReport = () => {
    navigate("/print-report-order-stock");
  };

  return (
    <>
      <PanelTemplate sidebarActiveLink="r-order-stock">
        <div className="panel-main-header mt-3 mr-2">
          <span> سفارش / موجودی</span>
        </div>
        <PanelFilter
          header="فیلتر :"
          list={filterList}
          update_filter={update_filter}
          filter={filter}
          reset_filter={reset_filter}
        />
        <div className="flex justify-end">
          <MuiButton
            onClick={handelPrintReport}
            variant="outlined"
            icon={<PrintIcon />}
            color="primary"
            text="چاپ گزارش"
            margin="mr-2"
          />
        </div>
        <PanelTable
          header="لیست النگوها:"
          headers={headersList}
          mobileHeaders={mobileHeadersList}
          data={requestList}
          dataKey={dataKey}
          buttons={buttonsList}
          actions={actionsList}
          icon={<AddShoppingCartIcon />}
          // setSelectedRow={setSelectedRow}
        />
      </PanelTemplate>
    </>
  );
};

export default AdminReportOrderStock;
